import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Art1 from '../images/Art Images/art-1.jpg';
import Art2 from '../images/Art Images/art-2.jpg';
import Art3 from '../images/Art Images/art-3.jpg';
import Art4 from '../images/Art Images/art-4.jpg';
import Art5 from '../images/Art Images/art-5.jpg';
import Art6 from '../images/Art Images/art-6.jpg';
import Art7 from '../images/Art Images/art-7.jpg';
import Art8 from '../images/Art Images/art-8.jpg';
import Art9 from '../images/Art Images/art-9.jpg';
import Art10 from '../images/Art Images/art-10.jpg';
import Art11 from '../images/Art Images/art-11.jpg';

const ArtStudio = () => {
    return (
        <div>
            <Helmet>
                <title>Kshiti :: Art Studio</title>
            </Helmet>
            <section className="home-hero alternate-hero">
                <div className="row">
                    <div className="col-70 home-hero-content">
                        <h1>Art Studio</h1>
                        <h2>I design & build <span className="highlight-color">Digital Products.</span></h2>
                        <p>I've worked at start-ups, tech companies and corporates on a range of different studios, including design systems, websites and apps.</p>
                    </div>
                </div>
            </section>
            {/*<section className='studio-row row'>
                <div className='col studio-col col-left'>
                    <div>
                        <h6 className="studio-heading">
                            01<span>Infinity Yoga Studio</span>
                        </h6>
                    </div>
                    <div className='studio-content-wrapper'>
                        <div className='studio-content'>
                            <img src={InfinityYoga} alt="studio - Infinity Yoga" className="studio-image" />
                            <h6><a href='/infinityyogastudio' className='studio-skills'>Bootstrap + Figma →</a></h6>
                        </div>
                    </div>
                </div>
                <div className='col studio-col col-right'>
                    <div>
                        <h6 className="studio-heading">
                            <span>studio Name</span>02
                        </h6>
                    </div>
                    <div className='studio-content-wrapper'>
                        <div className='studio-content'>
                            <img src={InfinityYoga} alt="studio - Infinity Yoga" className="studio-image" />
                            <h6><a href='' className='studio-skills'>Bootstrap + Figma →</a></h6>
                        </div>
                    </div>
                </div>
            </section>
            <section className='studio-row row'>
                <div className='col studio-col col-left'>
                    <div>
                        <h6 className="studio-heading">
                            03<span>studio Name</span>
                        </h6>
                    </div>
                    <div className='studio-content-wrapper'>
                        <div className='studio-content'>
                            <img src={InfinityYoga} alt="studio - Infinity Yoga" className="studio-image" />
                            <h6><a href='' className='studio-skills'>Bootstrap + Figma →</a></h6>
                        </div>
                    </div>
                </div>
                <div className='col studio-col col-right'>
                    <div>
                        <h6 className="studio-heading">
                            <span>studio Name</span>04
                        </h6>
                    </div>
                    <div className='studio-content-wrapper'>
                        <div className='studio-content'>
                            <img src={InfinityYoga} alt="studio - Infinity Yoga" className="studio-image" />
                            <h6><a href='' className='studio-skills'>Bootstrap + Figma →</a></h6>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className='parking-section'>
                <div className='container'>
                    <h2 className='container'>Kshiti is updating this section with her amazing projects. Hold on tight!</h2>
                    <h3>In the meantime, check out a few of her acrylic art pieces (yes, real canvas!).</h3>
                    <div className='art-wrap'> 
                        <div class="art-image-wrap">
                            <img src={Art1} alt="First Art Image" className="art-image" />
                        </div>
                        <div class="art-image-wrap">
                            <img src={Art2} alt="Second Art Image" className="art-image" />
                        </div>
                        <div class="art-image-wrap">
                            <img src={Art3} alt="Third Art Image" className="art-image" />
                        </div>
                        <div class="art-image-wrap">
                            <img src={Art4} alt="Fourth Art Image" className="art-image" />
                        </div>
                        <div class="art-image-wrap">
                            <img src={Art5} alt="Fifth Art Image" className="art-image" />
                        </div>
                        <div class="art-image-wrap">
                            <img src={Art6} alt="Sixth Art Image" className="art-image" />
                        </div>
                        <div class="art-image-wrap">
                            <img src={Art7} alt="Seventh Art Image" className="art-image" />
                        </div>
                        <div class="art-image-wrap">
                            <img src={Art8} alt="Eight Art Image" className="art-image" />
                        </div>
                        <div class="art-image-wrap">
                            <img src={Art9} alt="Ninth Art Image" className="art-image" />
                        </div>
                        <div class="art-image-wrap">
                            <img src={Art10} alt="Tenth Art Image" className="art-image" />
                        </div>
                        <div class="art-image-wrap">
                            <img src={Art11} alt="Eleven Art Image" className="art-image" />
                        </div>   
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ArtStudio;